import type { DepartmentId, ListId } from '@vlabs/api/artemy/model';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { attachAllCardsFromList } from './attachAllCardsFromList';
import { useDuplicateListTranslation } from './i18n';
import { useDuplicateList } from './useDuplicateList';

interface UseDuplicateListSubmitParams {
  listId: ListId;
  onSuccess?: VoidFunction;
}

function useDuplicateListSubmit({ listId, onSuccess = undefined }: UseDuplicateListSubmitParams):
(values: { user_data: string; departmentId: DepartmentId }) => Promise<void> {
  const { t } = useDuplicateListTranslation();
  const history = useHistory();
  const duplicateList = useDuplicateList(listId);

  const handleSubmit = async (values: { user_data: string; departmentId: DepartmentId }): Promise<void> => {
    try {
      const duplicatedList = await duplicateList(values);
      await attachAllCardsFromList({
        sourceListId: listId,
        targetListId: duplicatedList.list_id,
      });
      toast.success(t('toast_success'));
      history.push(generatePath(routes.lists.read, { listId: duplicatedList.list_id }));
      onSuccess?.();
    } catch {
      toast.error(t('toast_error'));
    }
  };

  return handleSubmit;
}

export { useDuplicateListSubmit };
